import React from 'react';
//import logo from '../../logo.jpeg'
import logo from '../../assets/images/logo_for_app_gmsV1.jpg'
import { useSelector } from 'react-redux';



const Header = () => {
  const eventName = useSelector(state => state.scheduleCreationData.eventName || state.slotPickupData.eventName);
  const eventNameHtml = eventName ? <p className="header_event_name">{eventName} Event</p> : null;

  return (
    <header className='header'>
          <img alt='logo' className='logo' src={logo} />
          {
              //<div className="logo-text">
              //    <h3 className='header_title'>Department of Administrative Services</h3>
              //    <p>Group Meeting Scheduler</p>
              //</div>
          }

      {/*eventNameHtml*/}
    </header>
  );
}

export default Header;